module.exports = __webpack_public_path__ + "img/MeetingHub-NavLogo-Big.149eaff1.png";